import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import KineticMarquee from "@/components/KineticMarquee";
import Network from "@/components/Network";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Trust from "@/components/Trust";
import About from "@/components/About";
import DualContact from "@/components/DualContact";
import Uploads from "@/components/Uploads";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let frame;
    function raf(time) {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    }
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="landing-page" className="relative">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <KineticMarquee />
        <Network />
        <Services />
        <Process />
        <Trust />
        <About />
        <DualContact />
        <Uploads />
      </main>
      <Footer />
    </div>
  );
}
